export default __webpack_public_path__ + "static/media/Committed-one.b2d69597.svg";